function getMenuId(baseId) {
  return baseId + "-menu";
}

export { getMenuId as g };